import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="p-4">
            <h2 className="fw-bold">404</h2>
            <p className="text-muted">Page not found.</p>
            <Link to="/" className="btn btn-primary">Go Dashboard</Link>
        </div>
    );
}
